/**
 * Service pour les opérations d'authentification
 * Aucune logique métier, uniquement des appels API
 */

import { api, endpoints } from './api.js'

export const authService = {
  me: () => api.get(endpoints.auth.me()),

  // `identifier` accepte un email (contient @) ou un NDC.
  login: (identifier, password) => api.post(endpoints.auth.login(), { identifier, password }),

  logout: () => api.post(endpoints.auth.logout())
}
